module.exports = __webpack_public_path__ + "static/media/Check.aa525cde.svg";